import axios from 'axios'

const services = {
  async getCellsListCount(gen = 2) {
    return await axios.get('/api/getpowerlistcount?gen=' + gen)
  },
  async getBalancedCellSummary() {
    return await axios.get('/api/cells/balancesummary')
  },
  async balanceCells(size, range) {
    return await axios.post('/api/cells/balancecells', { size, range })
  },
  async register(name, email, role) {
    return await axios.post('/api/register?name=' + name + '&email=' + email + '&role=' + role)
  },
  async usersdata() {
    return await axios.get('/api/usersdata')
  },
  async userdelete(userid) {
    return await axios.get(`/api/userdelete/${userid}`)
  },
  async getAllCells(gen) {
    return await axios.get('/api/getallcells/' + gen)
  },
  async deleteAllCells(gen) {
    return await axios.get('/api/deleteallcells/' + gen)
  },
  async getAvailableCellsList(limit, page, cell, searchTypes, query) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)
    const url = cell
      ? `/api/searchcell/${limit}/${page}/${offset}/${cell}`
      : `/api/getcellslist/${limit}/${page}/${offset}`
    let params = { ...query }
    if (cell) params.search = ['available', ...searchTypes];
    return await axios.get(url, { params })
  },
  async getCellsList(limit, page, cell, searchTypes, query) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)
    const url = cell
      ? `/api/searchcell/${limit}/${page}/${offset}/${cell}`
      : `/api/getcellslist/${limit}/${page}/${offset}`
    let params = { ...query }
    if (cell) params.search = searchTypes;
    return await axios.get(url, { params })
  },
  async getBalancedCellsList(limit, page, cell, searchTypes) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)
    const url = cell
      ? `/api/balancedcell/search/${limit}/${page}/${offset}/${cell}`
      : `/api/balancedcell/getcellslist/${limit}/${page}/${offset}`
    let params = {}
    if (cell) params = { search: searchTypes }
    return await axios.get(url, { params })
  },
  async searchCell(limit, page, cell, searchType) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    return await axios.get(
      '/api/searchcell/' +
      limit +
      '/' +
      page +
      '/' +
      offset +
      '/' +
      cell +
      '/' +
      searchType
    )
  },
  async getAllCellsList(limit, page, cell) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    const url = cell
      ? `/api/searchallcells/${limit}/${page}/${offset}/${cell}`
      : `/api/getallcellslist/${limit}/${page}/${offset}`
    return await axios.get(url)
  },
  async searchAllCells(limit, page, cell) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    return await axios.get(
      '/api/searchallcells/' + limit + '/' + page + '/' + offset + '/' + cell
    )
  },
  async deleteCells(cells) {
    return await axios.post('/api/deletecells', { cells: cells })
  },
  async updateCell(cell) {
    return await axios.post('/api/updatecell', { cell: cell })
  },
  async getBestBattery(
    number,
    max,
    min,
    gen,
    maxpower,
    minpower,
    maxvalue,
    minvalue
  ) {
    return await axios.get(
      '/api/getbestbattery/' +
      number +
      '/' +
      max +
      '/' +
      min +
      '/' +
      gen +
      '/' +
      maxpower +
      '/' +
      minpower +
      '/' +
      maxvalue +
      '/' +
      minvalue
    )
  },
  async getBestBalancedBattery(
    number,
    max,
    min,
    gen,
    maxpower,
    minpower,
    maxvalue,
    minvalue
  ) {
    return await axios.get(
      '/api/cells/getbestbalancedbattery/' +
      number +
      '/' +
      max +
      '/' +
      min +
      '/' +
      gen +
      '/' +
      maxpower +
      '/' +
      minpower +
      '/' +
      maxvalue +
      '/' +
      minvalue
    )
  },
  async createBattery(battery) {
    return await axios.post('/api/createtbattery', { data: battery })
  },
  async getBatteriesList(search, limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = '/api/batteries/'
    url += search ? search + '/' : ''
    url += limit ? limit + '/' : '10/'
    url += page ? page + '/' : '0/'
    url += offset ? offset : 0
    return await axios.get(url)
  },
  async getAvailableBatteriesList(search, limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = '/api/batteries/available/'
    url += search ? search + '/' : ''
    url += limit ? limit + '/' : '10/'
    url += page ? page + '/' : '0/'
    url += offset ? offset : 0
    return await axios.get(url)
  },
  async discardBattery(id) {
    return await axios.get('/api/discardbattery/' + id)
  },
  async getBatteriesNotInstalled(limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    return await axios.get(
      '/api/batteries/available/' + limit + '/' + page + '/' + offset
    )
  },
  async getBattery(id) {
    return await axios.get('/api/battery/' + id)
  },
  async cellscheck(id, payload) {
    return await axios.patch('/api/cellscheck/' + id, payload)
  },
  async updateBattery(id, update) {
    return await axios.patch('/api/battery/' + id, update)
  },
  async getCustomers(limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    return await axios.get('/api/customer/' + limit + '/' + page + '/' + offset)
  },
  async searchCustomers(search, limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = '/api/customer/'
    url += search ? search + '/' : ''
    url += limit ? limit + '/' : '10/'
    url += page ? page + '/' : '0/'
    url += offset ? offset : 0
    return await axios.get(url)
  },
  async getCustomerCars(customerId) {
    return await axios.get(`/api/customer/${customerId}/cars`)
  },
  async getCustomerAddresses(customerId) {
    return await axios.get(`/api/customer/${customerId}/addresses`)
  },
  async assignCustomerBattery(customerId, batteryId) {
    return await axios.post('/api/battery/assigncustomer', {
      customerId,
      batteryId
    })
  },
  async getCustomer(id) {
    return await axios.get('/api/customer/find/' + id)
  },
  async addCustomer(data) {
    return await axios.post('/api/customer', data)
  },
  async updateCustomer(id, data) {
    return await axios.post('/api/customer/' + id, data)
  },
  async editCustomer(data) {
    return await axios.put('/api/customer', { data: data })
  },
  async deleteCustomer(id) {
    return await axios.get('/api/customer/' + id)
  },
  async getCustomerCSV() {
    return await axios.get('/api/customer/csv');
  },
  async getSalesList(search, limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = '/api/getsalelist/'
    url += search ? search + '/' : ''
    url += limit ? limit + '/' : '10/'
    url += page ? page + '/' : '0/'
    url += offset ? offset : 0
    return await axios.get(url)
  },
  async addSale(data) {
    return await axios.post('/api/sale', data)
  },
  async addRecall(id, data) {
    return await axios.post('/api/sale/recall/' + id, data)
  },
  async getSale(id) {
    return await axios.get('/api/sale/find/' + id)
  },
  async updateSale(id, data) {
    return await axios.post('/api/sale/' + id, data)
  },
  async deleteSale(id) {
    return await axios.get('/api/sale/' + id)
  },
  async getSaleCSV() {
    return await axios.get('/api/sale/csv');
  },
  async getUnpaidJobs() {
    return await axios.get('/api/billing/unpaid')
  },
  async purgeBilling() {
    return await axios.get('/api/billing/purge')
  },

  


  async sendAppointmentForm(phone) {
    return await axios.get('/api/appointments/send-google-form', phone)
  },

  async sendMessage(phone) {
    return await axios.get('/api/appointments/message/' + phone)
  },
  async getAppointments(search, limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = '/api/appointments/'
    url += search ? 'search/' + search + '/' : 'get/'
    url += limit ? limit + '/' : '10/'
    url += page ? page + '/' : '0/'
    url += offset ? offset : 0
    return await axios.get(url)
  },
  async getSideMenu() {
    return await axios.get('/api/sideMenu');
  },
  async getLocationRates() {
    return await axios.get('/api/locationRates');
  },
}

// Agar aapne axios ko import kiya hua hai (jo ki usually top par hota hai)
// import axios from 'axios'; 

// export const batteriesapi = {
//     // Cell ID ke basis par batteries fetch karne ke liye
//     getByCellId(cellId) {
//         return axios.get(`/batteries-by-cell/${cellId}`);
//     },

//     // Agar aapko Customer details nikalni hain (2nd option ke liye)
//     getCustomerByCell(cellId) {
//         return axios.get(`/customer-by-cell/${cellId}`);
//     }
// };


export const batteriesapi = {
  getByCellId(cellId) {
    // Agar aapki baki APIs /api/ se chalti hain toh yahan bhi add karein
    return axios.get(`api/batteries-by-cell/${cellId}`);

    // Ya fir full URL dekar check karein (Testing ke liye)
    // return axios.get(`http://192.168.1{cellId}`);
  },
};


export const report = {
  async getCustomerReport(limit, page, data) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)
    return await axios.post(`/api/customer/report/${limit}/${offset}`, data);
  },
  async getAreaReport(data) {
    return await axios.post('/api/reports/area', data);
  },
  async getDayReport(data) {
    return await axios.post('/api/reports/days', data);
  }
}

export const balancedcells = {
  async summary() {
    return await axios.get('/api/balancedcell/summary')
  },
  async batch(size, range) {
    return await axios.post('/api/balancedcell/balancecells', { size, range });
  },
  async balancedCellsForBattery(size, range) {
    return await axios.post('/api/balancedcell/getbalancedcellforbattery', { size, range });
  },
  async updateVoltage(id, voltage) {
    return await axios.post(`/api/balancedcell/update/${id}`, { voltage });
  },
  async replaceCell(number, body) {
    return await axios.post(`/api/balancedcell/replacecell/${number}`, body);
  },
  async search(limit, page, cell) {
    page = parseInt(page) - 1;
    var offset = parseInt(limit) * parseInt(page);
    return await axios.get(`/api/balancedcell/search/${limit}/${page}/${offset}/${cell}`);
  },
  async group(limit, page) {
    page = parseInt(page) - 1;
    var offset = parseInt(limit) * parseInt(page);
    return await axios.get(`/api/balancedcell/group/${limit}/${page}/${offset}`);
  },
  async groupcells(date) {
    return await axios.get(`/api/balancedcell/groupcells/${date}`);
  },
  async balanceCellsById(cellIds) {
    return await axios.post(`/api/balancedcell/balancecellsById`, { cells: cellIds })
  }
}


export const reusebalancedcells = {
  async search(limit, page, cell) {
    page = parseInt(page) - 1;
    var offset = parseInt(limit) * parseInt(page);
    return await axios.get(`/api/reusebalancedcell/search/${limit}/${page}/${offset}/${cell}`);
  },
}


export const broadcastLists = {
  async getBroadcastLists(search, limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = '/api/get_broadcast_lists/'
    url += search ? search + '/' : ''
    url += limit ? limit + '/' : '10/'
    url += page ? page + '/' : '0/'
    url += offset ? offset : 0
    return await axios
      .get(url)
  },
  async getBroadcastList(id) {
    return await axios.get('/api/get_broadcast_list/' + id)
  },
  async updateBroadcastList(id, update) {
    return await axios.post('/api/update_broadcast_list/' + id, update)
  },
  async removeBroadcastList(id) {
    return await axios.get('/api/remove_broadcast_list/' + id)
  },
  async getMessageTemplates(search, limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = '/api/get_message_templates/'
    url += search ? search + '/' : ''
    url += limit ? limit + '/' : '10/'
    url += page ? page + '/' : '0/'
    url += offset ? offset : 0
    return await axios
      .get(url)
  },
  async getMessageTemplate(id) {
    return await axios.get('/api/get_message_template/' + id)
  },
  async updateMessageTemplate(id, update) {
    return await axios.post('/api/update_message_template/' + id, update)
  },
  async removeMessageTemplate(id) {
    return await axios.get('/api/remove_message_template/' + id)
  },
}

export const sale = {
  async getWarrantiedSalesList(search, limit, page) {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = '/api/get_warrantied_sales/'
    // url += search ? search + '/' : ''
    url += limit ? limit + '/' : '10/'
    url += page ? page + '/' : '0/'
    url += offset ? offset : 0

    if (search) url += `?search=${search}`
    return await axios.get(url)
  },
}

export const bookings = {
  getListItems(limit = 10, page = 1, search = "") {
    page = parseInt(page) - 1
    var offset = parseInt(limit) * parseInt(page)

    let url = `/api/booking/${limit}/${offset}`;

    if (search) url += `?search=${search}`;

    return axios.get(url);
  },
  getItem(id) {
    return axios.get(`/api/booking/${id}`);
  },
  deleteItem(id) {
    return axios.get(`/api/booking/${id}/delete`);
  },

  async sendGoogleForm(phone) {
    return await axios.get('/api/appointments/send-google-form?phone=' + phone)
  },
}
// $app->get('/balancedcell/search/{limit}/{page}/{offset}/{cell}', 'BalancedCellsController@searchCell');
// $app->get('/balancedcell/group/{limit}/{page}/{offset}', 'BalancedCellsController@getBalancedGroup');
// $app->get('/balancedcell/groupcells/{date}', 'BalancedCellsController@getGroupCells');

export const inventory = {
  getListItems(limit = 10, page = 1) {
    page = parseInt(page) - 1
    const offset = limit * page
    let url = `/api/inventory/${limit}/${page}/${offset}`

    return axios.get(url);
  },
  getItem(id) {
    return axios.get(`/api/inventory/${id}`);
  },
  deleteItem(id) {
    return axios.delete(`/api/inventory/${id}`);
  },
  addItem(payload) {
    return axios.put(`/api/inventory`, {
      item_name: payload.name,
      item_count: payload.count,
      ...payload
    });
  },
  editItem(id, payload) {
    return axios.patch(`/api/inventory/${id}`, {
      item_name: payload.name,
      item_count: payload.count,
      ...payload
    });
  },
  countInventory(countid, count, note) {
    return axios.post(`/api/inventory/${countid}/count/${count}/add`, {
      note: note
    });
  },
  history(name, limit = 10, page = 1) {
    page = parseInt(page) - 1
    const offset = limit * page
    return axios.get(`/api/inventory/${name}/history/${limit}/${page}/${offset}`);
  }
}


export default services



